// Instruments
import { createStorage } from 'helpers/storage';

export const compareStorage = createStorage('compare');
